import React from 'react';
import { Line } from 'react-chartjs-2';
import { Card, CardBody } from 'reactstrap';
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend
} from 'chart.js';

ChartJS.register(
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend
);

const DashboardLineChart = ({ data, options }) => (
  <Card className="mb-4 shadow-sm border-0">
    <CardBody>
      <Line data={data} options={options} height={80} />
    </CardBody>
  </Card>
);

export default DashboardLineChart;
